import { render, staticRenderFns } from "./ResourcePhotoPreviewsList.vue?vue&type=template&id=ebd3a2e8&scoped=true&"
import script from "./ResourcePhotoPreviewsList.vue?vue&type=script&lang=ts&"
export * from "./ResourcePhotoPreviewsList.vue?vue&type=script&lang=ts&"
import style0 from "./ResourcePhotoPreviewsList.vue?vue&type=style&index=0&id=ebd3a2e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd3a2e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebd3a2e8')) {
      api.createRecord('ebd3a2e8', component.options)
    } else {
      api.reload('ebd3a2e8', component.options)
    }
    module.hot.accept("./ResourcePhotoPreviewsList.vue?vue&type=template&id=ebd3a2e8&scoped=true&", function () {
      api.rerender('ebd3a2e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/resource-details/ResourcePhotoPreviewsList.vue"
export default component.exports